export default __webpack_public_path__ + "static/media/single.cd9e091a.dae";